import React, { useCallback, useEffect } from "react";
import { useStopwatch } from "react-timer-hook";
import { padStart } from "lodash";
import { useState } from "react";
import { type } from "../../pages/quiz/QuizRunner";
import { QuizyUrl } from "../../libs/env";

export function Timer({
  totalTimeInSeconds,
  onStop,
  data,
  localSpentTime,
  isStopTimer,
  nature_of_test,
  test_time_out,
  edit_template,
}) {
  const [timerClass, setTimerClass] = useState();
  let options = {
    autoStart: true,
  };
  let fsize = "p-1";
  if(edit_template === "true")
  {
    fsize="px-1";
  }
  const localTime = new Date();
  localTime.setSeconds(localTime.getSeconds() + parseInt(localSpentTime));

  if (localTime) {
    options = { ...options, offsetTimestamp: localTime };
  }
  const { seconds, minutes, pause, hours } = useStopwatch(options);
  let spent_minutes = padStart([`${minutes}`], [2], ["0"]);
  let spent_seconds = padStart([`${seconds}`], [2], ["0"]);
  const storeInLocalStorage = useCallback(() => {
    const timeInSeconds = seconds + minutes * 60 + hours * 60 * 60;
    if (timeInSeconds >= parseInt(totalTimeInSeconds * 60)) {
      onStop(timeInSeconds);
    }

    if (timeInSeconds >= parseInt((totalTimeInSeconds - 5) * 60)) {
      if (nature_of_test === type.Assessment && test_time_out) {
        setTimerClass("text-danger");
      }
    }
    if (nature_of_test === type.Assessment){
      window.sessionStorage.setItem("timer" + data.student_assessment_id, timeInSeconds);
    }
    else {
      window.sessionStorage.setItem("timer", timeInSeconds);
    }
   
  }, [minutes, seconds, hours, onStop, totalTimeInSeconds]);

  useEffect(() => {
    storeInLocalStorage();
  }, [storeInLocalStorage]);

  useEffect(() => {
    if (isStopTimer) {
      pause();
    }
  }, [isStopTimer, pause]);

  return (
    <span className={`bg-white rounded-2 ${fsize}`}>
      {window.location.origin.includes(QuizyUrl) ? (
        <div className={`inline text-darkblue ${timerClass}`}>
          <span>{spent_minutes}</span>:<span>{spent_seconds}</span>
        </div>
      ):(
        <div className={`inline ${timerClass}`}>
          <span>Time: </span>  <span>{spent_minutes}</span>:<span>{spent_seconds}</span>
        </div>
      )}
    </span>
  );
}
